module.exports = __webpack_public_path__ + "img/img_tuanduizucheng.4e9b905b.png";